import { HandlersCollection, Collection } from '@tblabs/truffle';
import { SelectableItem } from '../Models/SelectableItem';


export class SelectableList<T> 
{
    public OnSelectionChange = new HandlersCollection();

    private selectedItem: SelectableItem<T> | null = null;
    private selectableItems = new Collection<SelectableItem<T>>();
    
    constructor(items: Collection<T> | Array<T>)
    {
        if (items instanceof Array)
        {
            items = new Collection(items);
        }

        items.OnChange((items) =>
        {
            this.selectableItems.Load(...items.map(item => new SelectableItem(item)));
        }, true);
    }
    
    public Load(items: Array<T> | Collection<T>): void
    {
        if (items instanceof Collection)
        {
            this.selectableItems.Load(...items.Items.map(item => new SelectableItem(item)));
        }
        else if (Array.isArray(items))
        {
            this.selectableItems.Load(...items.map(item => new SelectableItem(item)));
        }
    }

    public get Items(): Collection<SelectableItem<T>>
    {
        return this.selectableItems;
    }

    public get AsArray(): T[]
    {
        return this.selectableItems.Items.map(item => item.Item);
    }

    public get Current(): SelectableItem<T> | null
    {
        return this.selectedItem;
    }

    public Select(item: SelectableItem<T> | null): void
    {
        if (!item)
        {
            return;
        }

        this.UnmarkSelected();
        this.selectedItem = item;
        this.selectedItem.IsMarked.True();
        this.OnSelectionChange.Call(this.selectedItem);
    }

    public SelectFirst(): void
    {
        this.UnmarkSelected();
        this.selectedItem = this.selectableItems.Items[0];
        this.selectedItem.IsMarked.True();
        this.OnSelectionChange.Call(this.selectedItem);
    }

    public Next(): void
    {
        const currentItemIndex = this.selectableItems.Items.findIndex(item => item.IsMarked.value) || 0;
        const nextItemIndex = currentItemIndex + 1 === this.selectableItems.Count ? 0 : currentItemIndex + 1;
        const nextItem = this.selectableItems.Items[nextItemIndex];
        this.Select(nextItem);
    }

    public Previous(): void
    {
        const currentItemIndex = this.selectableItems.Items.findIndex(item => item.IsMarked.value);
        const previousItemIndex = currentItemIndex - 1 < 0 ? this.selectableItems.Count - 1 : currentItemIndex - 1;
        const previousItem = this.selectableItems.Items[previousItemIndex];
        this.Select(previousItem);
    }

    public Random(): void
    {
        let randomIndex = 3 + Math.floor(Math.random() * this.selectableItems.Count);
        randomIndex %= this.selectableItems.Count;
        const randomItem = this.selectableItems.Items[randomIndex];
        this.Select(randomItem);
    }

    private UnmarkSelected(): void
    {
        if (this.selectedItem)
        {
            this.selectedItem.IsMarked.False();
        }
    }

    public GetSelected(): T[]
    {
        return this.selectableItems.Items.filter(item => item.IsSelected.value).map(item => item.Item);
    }
}
